/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import io from "socket.io-client";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import IMPORT_LAYER_VIA_SEARCH from "./IMPORT_LAYER_VIA_SEARCH";

/*REDUX*/
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { set_value_properties } from "../../App/actions/propertiesActions";
import { get_pda, get_pch } from "../../App/actions/iotActions";
import { get_layer_detail_custom_api } from "../../App/actions/openApiActions";
import { view_layer, set_layer_id } from "../../App/actions/dataActions";
import {
  setLayer,
  setTabelStatus,
  setEditGeometry,
  setRealtimeStatus,
  setLayerWOgeojson,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
  setViewLayer,
  set_value_layer,
} from "../../App/actions/layerActions";
import { getProjectList } from "../../App/actions/projectActions";
import { set_value_toolbox } from "../../App/actions/toolboxActions";

/*PICTURE*/
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";
import ICON_TABLE from "../../Assets/jsx/ICON_TABLE";
import ICON_GEOMETRY from "../../Assets/jsx/ICON_GEOMETRY";

import icon_search from "../../Assets/svg/icon_search.svg";
import icon_import from "../../Assets/svg/icon_import.svg";

/*FUNCTION*/
import getStatusMember from "../../App/validation/get-status-member";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const SOCKET_URL_MAPID = "https://socket.mapid.io";
const geo_layer_status_that_editable_properties = [
  "original",
  "digitasi",
  "upload",
  "site_selection",
  "SS_MANUAL",
];

class SEARCH_LAYER extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_import: false,
    };

    this.socket = io.connect(SOCKET_URL_MAPID, {
      secure: true,
      reconnection: true,
      rejectUnauthorized: false,
    });
  }

  getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  handle_subscribe_socket = (user, layerId) => {
    // document.addEventListener('mousemove', (event) => this.handleMouseMove(event, user, layerId));
    this.socket.emit("from_mapid_backend", {
      data: { ...user, idLayer: layerId, borderColor: this.getRandomColor() },
      topic: "userUpdate",
    });
    this.setState({ IDLayer: layerId });
    // this.props.onToggleCursor(user, layerId);
  };

  handle_pre_subscribe_socket = (dataId) => {
    const { _id, name, full_name, email, profile_picture } =
      this.props.auth?.user;
    const user_data = {
      _id,
      name,
      full_name,
      email,
      profile_picture,
    };
    this.handle_subscribe_socket(user_data, dataId);
    this.setState({ IDLayer: [dataId] });
  };

  on_search_inside = (geo_layer_id, geo_layer_name) => {
    this.props.set_value_properties({
      key: "mode_search",
      value: "search_inside",
    });
    this.props.set_value_properties({
      key: "layer_id_search_inside",
      value: geo_layer_id,
    });
    this.props.set_value_properties({
      key: "layer_name_search_inside",
      value: geo_layer_name,
    });
  };

  toggle_import = (geo_layer_id) => {
    this.setState({ modal_import: !this.state.modal_import }, () => {
      if (this.state.modal_import) {
        const { isAuthenticated } = this.props.auth;
        if (isAuthenticated) {
          this.props.getProjectList();
        }
        this.props.set_layer_id(geo_layer_id);
        this.setState({ import_progress: false });
      }
    });
  };

  on_view_layer = (geo_layer_item, value, folder_id) => {
    this.props.on_deactivate_input_status();
    //layer yang saat ini sedang aktif (layer yang diklik bisa jadi sama, bisa jadi beda)
    const { layer_id } = this?.props?.layer;
    if (
      (layer_id !== geo_layer_item?._id &&
        geo_layer_item?.geojson?.features?.length === 0) ||
      !geo_layer_item?.geojson?.features
    ) {
      //kemungkinan 1: belum ada geojson, ambil geojson dulu, kemudian aktifkan view
      if (geo_layer_item?.type_2 === "pch") {
        this.props.get_pch(geo_layer_item);
      } else if (geo_layer_item?.type_2 === "pda") {
        this.props.get_pda(geo_layer_item);
      } else {
        if (geo_layer_item?.is_custom_endpoint) {
          this.props.get_layer_detail_custom_api(geo_layer_item._id);
        } else {
          const { geo_project } = this.props.project;
          const body = {
            geo_layer_id: geo_layer_item._id,
            geo_project_id: geo_project._id,
            folder_id: folder_id,
            capex_value: this.props.properties.capex_value,
            geo_layer_item,
          };
          this.props.getDetailLayerById(body);
        }
      }
    } else {
      //kemungkinan 2: sudah ada geojson, langsung toggle view
      const body = { geo_layer_id: geo_layer_item._id, value };
      this.props.view_layer(body);
    }
  };

  toggle_edit_geometry = (geo_layer_item, folder_id) => {
    this.props.on_deactivate_input_status();
    const { geometryStatus, layer_id, map_object } = this.props.layer;
    const { geo_project } = this.props.project;
    if (!geometryStatus) {
      //tidak aktif ke AKTIF
      const { type, architecture } = geo_layer_item;
      this.props.set_value_layer({
        key: "current_architecture",
        value: architecture,
      });
      this.props.set_value_layer({
        key: "current_type",
        value: type,
      });
      this.props.set_value_toolbox({
        key: "mode_draw",
        value: "simple_select",
      });
      this.handle_pre_subscribe_socket(geo_layer_item._id);
      this.props.set_value_layer({
        key: "draw_state_platform",
        value: "geometry",
      });
      const geojson = geo_layer_item?.geojson || {
        type: "FeatureCollection",
        features: [],
      };

      const draw_object = this.props.layer.draw_object;

      if (draw_object) {
        draw_object.add(geojson);
        draw_object.changeMode("simple_select");
      }

      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }
    } else {
      //aktif ke TIDAK AKTIF
      this.props.set_value_layer({
        key: "draw_state_platform",
        value: "",
      });
      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }

      const draw_object = this.props.layer.draw_object;

      if (draw_object) {
        draw_object?.changeMode("simple_select"); //deactivate draw mode
        draw_object?.deleteAll();
      }
    }

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = this.props.layer;
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        const body = { geo_layer_id: geo_layer_item._id, value: true };
        this.props.view_layer(body);
        this.setState({
          modal_bounding_box: true,
        });
        layer_id_bound.push(geo_layer_item?._id);
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (layer_id !== geo_layer_item._id) {
        if (!geo_layer_item?.geojson?.features?.length) {
          if (geo_layer_item?.type_2 === "pch") {
            this.props.get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            this.props.get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              this.props.get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const { geo_project } = this.props.project;
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                folder_id: folder_id,
                capex_value: this.props.properties.capex_value,
                geometryStatus: !geometryStatus,
                geo_layer_item,
              };
              this.props.getDetailLayerById(body);
            }
          }
          this.handle_pre_subscribe_socket(geo_layer_item._id);
        } else {
          this.props.set_layer_id(geo_layer_item._id);
          this.props.setEditGeometry(!geometryStatus);
        }
      } else {
        if (!geo_layer_item?.geojson?.features?.length) {
          const body = {
            geo_layer_id: geo_layer_item._id,
            geo_project_id: geo_project._id,
            folder_id,
            capex_value: this.props.properties.capex_value,
            geometryStatus: !geometryStatus,
            geo_layer_item,
          };
          this.props.getDetailLayerById(body);
          this.handle_pre_subscribe_socket(geo_layer_item._id);
        } else {
          this.props.set_layer_id(geo_layer_item._id);
          this.props.setEditGeometry(!geometryStatus);
        }
      }
    }
  };

  toggle_edit_property = (geo_layer_item, folder_id) => {
    this.props.on_deactivate_input_status();
    const { tableStatus, layer_id } = this.props.layer;
    const { geo_project } = this.props.project;
    //Jika layer yang diklik bukanlah layer yang sedang aktif--> aktifkan layer
    if (layer_id !== geo_layer_item._id) {
      //Jika layer belum memiliki geojson, ambil geojson via API
      if (
        geo_layer_item?.geojson?.features?.length === 0 ||
        !geo_layer_item?.geojson?.features
      ) {
        this.props.setTabelStatus(true);
        //kemungkinan 1: belum ada geojson, ambil geojson dulu, kemudian aktifkan view
        if (geo_layer_item?.type_2 === "pch") {
          this.props.get_pch(geo_layer_item);
        } else if (geo_layer_item?.type_2 === "pda") {
          this.props.get_pda(geo_layer_item);
        } else {
          if (geo_layer_item?.is_custom_endpoint) {
            this.props.get_layer_detail_custom_api(geo_layer_item._id);
          } else {
            const body = {
              geo_layer_id: geo_layer_item._id,
              geo_project_id: geo_project._id,
              folder_id,
              capex_value: this.props.properties.capex_value,
              tableStatus: true,
              geo_layer_item,
            };
            this.props.getDetailLayerById(body);
          }
        }
      } else {
        //Jika layer sudah memiliki geojson --> aktifkan layer tanpa mengambil geojson lagi
        this.props.set_layer_id(geo_layer_item._id);
        this.props.setTabelStatus(true);
      }
    } else {
      //Jika layer yang diklik adalah layer yang sedang aktif
      //Jika layer awalnya kosong, coba cek ke API lagi, barangkali sekarang ada isinya
      if (
        geo_layer_item?.geojson?.features?.length === 0 ||
        !geo_layer_item?.geojson?.features
      ) {
        this.props.setTabelStatus(!tableStatus);
        if (geo_layer_item?.type_2 === "pch") {
          this.props.get_pch(geo_layer_item);
        } else if (geo_layer_item?.type_2 === "pda") {
          this.props.get_pda(geo_layer_item);
        } else {
          if (geo_layer_item?.is_custom_endpoint) {
            this.props.get_layer_detail_custom_api(geo_layer_item._id);
          } else {
            const body = {
              geo_layer_id: geo_layer_item._id,
              geo_project_id: geo_project._id,
              folder_id,
              capex_value: this.props.properties.capex_value,
              tableStatus: !tableStatus,
              geo_layer_item,
            };
            this.props.getDetailLayerById(body);
          }
        }
      } else {
        this.props.set_layer_id(geo_layer_item._id);
        this.props.setTabelStatus(!tableStatus);
      }
    }
  };

  toggle_chat_on_layer = (geo_layer_item) => {
    let { geo_layer_wo_geojson, chatStatus } = this.props.layer;
    geo_layer_wo_geojson = geo_layer_wo_geojson?.geo_layer;
    if (geo_layer_wo_geojson?._id !== geo_layer_item?._id) {
      const content = {
        geo_layer: geo_layer_item,
      };
      this.props.setLayerWOgeojson(content);
      this.props.setChatStatus(true);
    } else {
      const content = {
        geo_layer: geo_layer_item,
      };
      this.props.setLayerWOgeojson(content);
      this.props.setChatStatus(!chatStatus);
    }
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const { modal_import } = this.state;

    //global props
    const { layer_id_filtered, search_input, shared_link_check } =
      this.props.properties;
    const {
      tableStatus,
      geo_layer_list,
      layer_id,
      layer_id_active,
      geometryStatus,
      geo_layer_wo_geojson,
      chatStatus,
    } = this.props.layer;
    const { isAuthenticated } = this.props.auth;
    const { geo_project } = this.props.project;

    //content
    const is_project_public = geo_project?.isPublic;

    const role = shared_link_check?.role;
    let is_author = false;
    if (isAuthenticated) {
      let userCurrentStatus;
      const { user } = this.props.auth;
      const { geo_project } = this.props.project;
      const groups = geo_project?.groups || [];
      if (geo_project?._id) {
        userCurrentStatus = getStatusMember(groups, user?._id);
      }
      is_author =
        !!userCurrentStatus || !!(geo_project?.user?._id === user?._id);
    }

    let layer_final;

    if (!search_input) {
      layer_final = geo_layer_list;
    } else {
      layer_final = geo_layer_list.filter((item) =>
        layer_id_filtered.includes(item?.geo_layer?._id)
      );
    }

    const content = (
      <section
        style={{
          overflowY: "auto",
          height: "500px",
          maxHeight: "calc((100vh - 300px))",
          marginTop: "20px",
        }}
      >
        {layer_final.map((layer_item, idx) => {
          const geo_layer = layer_item?.geo_layer ? layer_item.geo_layer : {};
          const folder_id = layer_item?.folder || "";
          const status = layer_item?.status;
          const { _id, name, description, architecture } = geo_layer;
          const viewStatus = layer_id_active.includes(geo_layer?._id);
          return (
            <main
              key={idx}
              className="container_light button_white margin_bottom outline_grey"
            >
              <p className="text_bold margin_bottom">{name}</p>
              {!!description && (
                <p className="text_small max_two_lines">{description}</p>
              )}

              <section className="layer_action_section">
                <div
                  className="cursor_pointer layer_action_item"
                  onClick={this.on_view_layer.bind(
                    this,
                    geo_layer,
                    !viewStatus,
                    folder_id
                  )}
                  data-mapid={`clickTutupMata-${idx}`}
                >
                  <ICON_VIEW
                    color={viewStatus ? "#000" : "#696969"}
                    strokeWidth={viewStatus ? 4 : 3}
                    style={{ width: "27px", height: "27px" }}
                  />
                  <p
                    className={`layer_action_label ${
                      viewStatus ? "active_label" : "inactive_label"
                    }`}
                  >
                    {dict?.["View"]?.[language]}
                  </p>
                </div>

                {(is_author ||
                  role === "viewer_download" ||
                  role === "editor") &&
                  geo_layer_status_that_editable_properties.includes(status) &&
                  architecture !== "api" && (
                    <div
                      className="cursor_pointer layer_action_item"
                      onClick={this.toggle_edit_geometry.bind(
                        this,
                        geo_layer,
                        folder_id
                      )}
                      data-mapid={`clickBukaDigitasi-${idx}`}
                    >
                      <ICON_GEOMETRY
                        color={
                          _id === layer_id && geometryStatus
                            ? "#000"
                            : "#696969"
                        }
                        strokeWidth={_id === layer_id && geometryStatus ? 4 : 3}
                        style={{ width: "27px", height: "27px" }}
                      />
                      <p
                        className={`layer_action_label ${
                          _id === layer_id && geometryStatus
                            ? "active_label"
                            : "inactive_label"
                        }`}
                      >
                        {dict?.["Geometry"]?.[language]}
                      </p>
                    </div>
                  )}

                <div
                  className="cursor_pointer layer_action_item"
                  onClick={this.toggle_edit_property.bind(
                    this,
                    geo_layer,
                    folder_id
                  )}
                  data-mapid={`clickBukaTable-${idx}`}
                >
                  <ICON_TABLE
                    color={_id === layer_id && tableStatus ? "#000" : "#696969"}
                    strokeWidth={_id === layer_id && tableStatus ? 4 : 3}
                    style={{ width: "27px", height: "27px" }}
                  />
                  <p
                    className={`layer_action_label ${
                      _id === layer_id && tableStatus
                        ? "active_label"
                        : "inactive_label"
                    }`}
                  >
                    {dict?.["Table"]?.[language]}
                  </p>
                </div>

                {(is_author ||
                  role === "viewer_download" ||
                  role === "editor" ||
                  is_project_public) && (
                  <div
                    className="cursor_pointer layer_action_item"
                    onClick={this.on_search_inside.bind(this, _id, name)}
                  >
                    <img
                      src={icon_search}
                      alt={dict["Search"][language]}
                      height="27px"
                      style={{ margin: "auto" }}
                    />
                    <p
                      className={`layer_action_label ${
                        _id === geo_layer_wo_geojson?.geo_layer?._id &&
                        chatStatus
                          ? "active_label"
                          : "inactive_label"
                      }`}
                    >
                      {dict["Search"][language]}
                    </p>
                  </div>
                )}

                {(is_author ||
                  role === "viewer_download" ||
                  role === "editor" ||
                  is_project_public) && (
                  <div
                    className="cursor_pointer layer_action_item"
                    onClick={this.toggle_import.bind(this, geo_layer?._id)}
                  >
                    <img
                      src={icon_import}
                      alt={dict["Import"][language]}
                      height="27px"
                      style={{ margin: "auto" }}
                    />
                    <p
                      className={`layer_action_label ${
                        _id === geo_layer_wo_geojson?.geo_layer?._id &&
                        chatStatus
                          ? "active_label"
                          : "inactive_label"
                      }`}
                    >
                      {dict["Import"][language]}
                    </p>
                  </div>
                )}
              </section>
            </main>
          );
        })}
      </section>
    );

    const modal_import_content = modal_import && (
      <Modal
        modalSize="large"
        isOpen={modal_import}
        onClose={this.toggle_import}
      >
        <div className="box-body" id="box-body">
          <IMPORT_LAYER_VIA_SEARCH />
        </div>
      </Modal>
    );

    return (
      <main>
        {modal_import_content}
        {!search_input && (
          <p className="text_small margin_bottom">
            {
              dict?.[
                "Search for layers in this project by typing their names or descriptions as keywords"
              ]?.[language]
            }
          </p>
        )}
        {!search_input && layer_id_filtered.length === 0 && (
          <section>
            <span className="button_pill_small background_black margin_right inline">
              {geo_layer_list.length}
            </span>
            <p className="text_medium inline">{dict?.["Layers"]?.[language]}</p>
          </section>
        )}
        {layer_id_filtered.length === 0 && !!search_input && (
          <p className="text_medium">{dict?.["No result"]?.[language]}</p>
        )}
        {layer_id_filtered.length > 0 && (
          <section>
            <span className="button_pill_small background_black margin_right inline">
              {layer_id_filtered.length}
            </span>
            <p className="text_medium inline">{dict?.["Result"]?.[language]}</p>
          </section>
        )}
        {content}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  map: state.map,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  getDetailLayerById,
  set_value_properties,
  get_pda,
  get_pch,
  get_layer_detail_custom_api,
  view_layer,
  set_layer_id,
  setLayer,
  setTabelStatus,
  setEditGeometry,
  setRealtimeStatus,
  setLayerWOgeojson,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
  setViewLayer,
  getProjectList,
  set_value_layer,
  set_value_toolbox,
})(SEARCH_LAYER);
